<div class="page-layout blank p-24 inner-scroll" fusePerfectScrollbar>
  <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="changeTab($event)" mat-align-tabs="start">
    <mat-tab label="Report Viewer">
      <div id="reports-container">
        <div id="service-mode-message" *ngIf="includeServiceMode">
          <div class="fa-solid fa-triangle-exclamation"></div>
          <span>Viewing activity during <strong>Service Mode</strong></span>
        </div>
        <div id="reports-viewer">
          <div id="reports-nav" (click)="reportChange($event)" [attr.loader]="showLoader" [attr.selected]="reportIndex">
            <span class="reports-btn" *ngIf="!streamline">Deployment Details</span>
            <span class="reports-btn" *ngIf="!streamline">Deployment Overview</span>
            <span class="reports-btn">Device Alerts</span>
            <span class="reports-btn">System Report</span>
          </div>
          <div id="reports-view">
            <div id="reports-tools" [attr.enabled]="!showLoader">
              <div class="reports-btn" [attr.enabled]="reportIndex != 1" (click)="filter()">
                <div class="fa-solid fa-filter"></div>
                <span>Filter</span>
              </div>
              <div class="reports-btn" (click)="share()">
                <div class="fa-solid fa-share-nodes"></div>
                <span>Share</span>
              </div>
              <div class="reports-btn" (click)="exportCSV()">
                <div class="fa-solid fa-table"></div>
                <span>Export CSV</span>
              </div>
            </div>
            <div id="reports-pdf-view">
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Scheduled Reports">
      <div id="scheduled-container">
        <div id="sch-btns">
          <button id="sch-create-report" (click)="createReport()">Create Report</button>
          <button id="sch-disable-reports" (click)="disableAllReports()">Disable All Reports</button>
        </div>
        <div id="sch-table">
          <div>
            <table>
              <thead>
                <tr>
                  <th>Report Name</th>
                  <th>Report Type</th>
                  <th>Report Interval</th>
                  <th>Next Report</th>
                  <th>Enabled</th>
                  <th>Edit</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let report of scheduledReports; let i = index">
                  <td>{{report.settings.name}}</td>
                  <td>{{level[report.settings.level]}}</td>
                  <td>{{reportInterval(report)}}</td>
                  <td>{{report.next_report ? toLocalTime(report.next_report) : 'n/a'}}</td>
                  <td (click)="toggleEnableReport(report)">
                    <div class="fa-regular fa-circle-check" *ngIf="report.enabled"></div>
                    <div class="fa-regular fa-circle-xmark" *ngIf="!report.enabled"></div>
                  </td>
                  <td (click)="createReport(report)">
                    <div class="fa-solid fa-pen-to-square"></div>
                  </td>
                  <td (click)="deleteReport(i)">
                    <div class="fa-regular fa-trash-can" *ngIf="report.settings.level !== 4"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div id="service-mode-toggle" class="reports-btn" (click)="toggleServiceMode()" [attr.toggled]="includeServiceMode">
    <span>Service Mode</span>
    <div [ngClass]="[includeServiceMode ? 'fa-solid fa-circle' : 'fa-regular fa-circle']"></div>
  </div>
</div>